module.exports = __webpack_public_path__ + "static/media/epic.d6259d3c.svg";